<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-button
        size="small"
        type="primary"
        v-code="12101"
        data-target="#module-modal"
        data-toggle="modal"
        >添加角色</el-button
      >
      <el-table :data="roles" style="width: 100%" size="small">
        <el-table-column prop="name" label="角色名称"></el-table-column>
        <el-table-column
          prop="function_module_names"
          label="关联模块"
        ></el-table-column>
        <el-table-column prop="role_names" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              plain
              v-code="12102"
              @click.native="handleShowModal(scope.row, scope.$index)"
              >编辑</el-button
            >

            <el-button
              size="mini"
              type="primary"
              plain
              v-code="12103"
              @click="$router.push('/roles/' + scope.row.id + '/auth')"
              >权限管理</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      class="modal"
      id="module-modal"
      role="dialog"
      tabindex="-1"
      aria-labelledby="demo-default-modal"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <!--Modal header-->
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              <i class="pci-cross pci-circle"></i>
            </button>
            <h4 class="modal-title">{{ role.id ? '编辑角色' : '添加角色' }}</h4>
          </div>

          <form @submit.prevent="handleRoleSubmit">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <form class="form-horizontal">
                    <div class="form-group">
                      <label class="col-md-4 control-label">名称</label>
                      <div class="col-md-4">
                        <input
                          type="text"
                          placeholder="角色名"
                          :class="{ error: $v.role.name.$error }"
                          class="form-control input-md"
                          v-model="role.name"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                data-dismiss="modal"
                class="btn btn-default"
                type="button"
              >
                取消
              </button>
              <button class="btn btn-primary">保存</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { roleList, roleNew, roleUpdate } from '@/service/getData'
import { required, maxLength } from 'vuelidate/lib/validators'
import { deepClone } from '@/utils'

export default {
  data() {
    return {
      role: {
        id: 0,
        index: 0,
        name: null,
      },
      roles: [],
    }
  },
  validations: {
    role: {
      name: {
        required,
        maxLength: maxLength(30),
      },
    },
  },
  mounted() {
    let that = this
    $('#module-modal').on('hide.bs.modal', function () {
      that.$v.$reset()
      that.role.id = 0
      that.role.name = null
    })
  },
  created() {
    this.initData()
  },
  methods: {
    unique(array) {
      var res = array.filter(function (item, index, array) {
        return array.indexOf(item) === index
      })
      return res
    },
    async initData() {
      let res = await roleList()
      if (res.status != 0) return false
      res.data.map((item) => {
        let arr = this.unique(item.function_module_names)
        item.function_module_names = arr.length > 0 ? arr.join('、') : '-'
      })
      this.roles = res.data
    },
    async handleRoleSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.role.id) {
          let res = await roleUpdate(this.role)
          if (res.status != 0) return false
          this.$set(this.roles, this.role.index, res.data)
        } else {
          let res = await roleNew(this.role)
          if (res.status != 0) return false
          this.roles.unshift(res.data)
        }
        $('#module-modal').modal('hide')
      }
    },
    handleShowModal(item, index) {
      this.role = deepClone(item)
      this.role.index = index
      $('#module-modal').modal('show')
    },
  },
}
</script>